module.exports = __webpack_public_path__ + "static/media/seasons-01.85ec2dc1.png";